//#region Old Code
 
// import React from 'react';
// import DocTitle from 'react-document-title';
// import Login from '../Login';
// import Header from '../Header';
// import request from 'arcdynamic-request';
// import Sidebar from '../Sidebar';
// import {browserHistory} from "react-router";
 
// export default class Root extends React.Component {
//  constructor(props) {
//      super(props);
 
//      this.state = {
//          user: null,
//          isSuper: null,
//          isAgent: null,
//          isSeniorAgent: null,
//          showMenu: true,
//          userData: null,
//          isHscUser: null
//      };
 
//      this.setUser = this.setUser.bind(this);
//      this.signOut = this.signOut.bind(this);
//      this.handleKeyDown = this.handleKeyDown.bind(this);
//  }
 
//     componentDidMount() {
//      request(arc.path.api, {
//          service: 'arcimedes',
//          action: 'Authentication.getStatus',
//      }).then(res => {
//          if (res && res.success) {
//              this.setUser(res.data);
//          } else {
//              this.setUser(false);
//          }
//      })
//  }
 
//  handleKeyDown(e) {
//      // Scheme to only show the focus outline when the user has used keyboard navigation to focus an element.
//      if (e.key === 'Tab') {
//          setTimeout(()=>{
//              if (this.activeElement !== document.activeElement) {
//                  if (this.activeElement) {
//                      this.activeElement.removeAttribute('data-focused');
//                  }
//                  if (document.activeElement) {
//                      this.activeElement = document.activeElement;
//                      this.activeElement.setAttribute('data-focused', true);
//                  }
//              }
//          }, 0);
//      }
//  }
 
//  setUser(user) {
//      if (user) {
//          Promise.all([
//              request(arc.path.api, {
//                  service: 'arcimedes',
//                  action: 'open.dataquery.execute',
//                  params: ['PERMISSIONS_TEST'],
//              }),
//                 request(arc.path.api, {
//                     service: 'arcimedes',
//                     action: 'open.User.get',
//                     params: ['code', 'USERS', {}],
//                 }),
//          ]).then(res => {
//              this.setState({
//                  user,
//                     isSuper: res[0].success && res[1].success && res[1].data && res[1].data._ext && res[1].data._ext.USER_TYPE === 'admin',
//                  isAgent: res[1].success && res[1].data && res[1].data._ext && res[1].data._ext.USER_TYPE === 'agent',
//                  isSeniorAgent: res[1].success && res[1].data && res[1].data._ext && res[1].data._ext.USER_TYPE === 'senior agent',
//                  userData: res[1].success && res[1].data,
//                  isHscUser: res[1].success && res[1].data && res[1].data.email && res[1].data.email.includes('highstcapital.com')
//              });
//              // if(res[0].success && res[1].success && res[1].data && res[1].data.email && res[1].data.email.includes('highstcapital.com')) {
//              //  browserHistory.push({
//              //      pathname: "/hsc-stats"
//              //  });
//              // }
//          });
//      } else {
//          this.setState({
//              user,
//              isSuper: false,
//              isAgent: false,
//              isSeniorAgent:false,
//              userData: false,
//          });
//      }
//  }
 
//  signOut() {
//      request(arc.path.api, {
//          service: 'arcimedes',
//          action: 'Authentication.logout',
//      });
 
//      this.setState({
//          user: false,
//          isSuper: false,
//             isAgent: false,
//          isSeniorAgent: false,
//             userData: false,
//         });
//  }
 
//  render() {
//      const { user, isSuper, isAgent, userData, isSeniorAgent,isHscUser } = this.state;
 
//      if (user === null) return null;
//      return (
//          <div className='Root' onKeyDown={this.handleKeyDown}>
//              <DocTitle title='STRIVE'/>
//              <Header location={this.props.location} isSuper={isSuper} isAgent={isAgent} isSeniorAgent={isSeniorAgent} pathname={this.props.location.pathname}/>
//              <Sidebar signOut={user ? this.signOut : null} location={this.props.location} isSuper={isSuper} isAgent={isAgent} isSeniorAgent={isSeniorAgent} pathname={this.props.location.pathname} isHscUser={isHscUser}>
//                     {
//                         user ? React.cloneElement(this.props.children, {isSuper, isAgent, userData, isSeniorAgent}) : <Login setUser={this.setUser}/>
//                     }
//              </Sidebar>
//          </div>
//      );
//  }
// }
 
//#endregion
 
import React, { createContext } from 'react';
import DocTitle from 'react-document-title';
import Login from '../Login';
import Header from '../Header';
import request from 'arcdynamic-request';
import Sidebar from '../Sidebar';
import { browserHistory } from "react-router";
import { ApolloConsumer } from '@apollo/client';
import ChangePassword from '../ChangePassword/ChangePassword';
 
export const UserContext = createContext();

export default class Root extends React.Component {
    constructor(props) {
        super(props);
 
        this.state = {
            user: null,
            isSuper: null,
            isAgent: null,
            isSeniorAgent: null,
            showMenu: true,
            userData: null,
            isHscUser: null,
            showChangePassword: false
        };
 
        this.client = null;
        this.setUser = this.setUser.bind(this);
        this.signOut = this.signOut.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
    }
 
    componentDidMount() {
        this.clearCookies();
        const token = localStorage.getItem('authToken');  // Check if the token is in localStorage
        if (token) {
            const decodedToken = this.parseJWT(token);
            if (decodedToken) {
                this.setUser(decodedToken);  // Use the decoded token to set the user
            }
        } else {
            // request(arc.path.api, {
            //  service: 'arcimedes',
            //  action: 'Authentication.getStatus',
            // }).then(res => {
            //  if (res && res.success) {
            //      this.setUser(res.data);
            //  } else {
            //      this.setUser(false);
            //  }
            // })
            this.setUser(false);
        }
    }
    parseJWT(token) {
        if(token){
        const base64Url = token.split('.')[1];  // The payload is the second part of the JWT
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
 
        return JSON.parse(jsonPayload);
    }
    }
 
    handleKeyDown(e) {
        // Scheme to only show the focus outline when the user has used keyboard navigation to focus an element.
        if (e.key === 'Tab') {
            setTimeout(() => {
                if (this.activeElement !== document.activeElement) {
                    if (this.activeElement) {
                        this.activeElement.removeAttribute('data-focused');
                    }
                    if (document.activeElement) {
                        this.activeElement = document.activeElement;
                        this.activeElement.setAttribute('data-focused', true);
                    }
                }
            }, 0);
        }
    }
 
    setUser(user) {
        if (user) {
            var token = localStorage.getItem('authToken');
            const decodedToken = this.parseJWT(token);
            // const userType = decodedToken.role;
            // const email = decodedToken.email;
            const userType = token ? decodedToken.role : "";
            const email =  token ? decodedToken.email : "";
            const userData = decodedToken;
            sessionStorage.setItem("userData", JSON.stringify(userData));
            const type = token ? decodedToken.type: "";
            // Promise.all([
            //     request(arc.path.api, {
            //         service: 'arcimedes',
            //         action: 'open.dataquery.execute',
            //         params: ['PERMISSIONS_TEST'],
            //     }),
            //     // request(arc.path.api, {
            //     //     service: 'arcimedes',
            //     //     action: 'open.User.get',
            //     //     params: ['code', 'USERS', {}],
            //     // }),
            //     // this.client.query({ query: GET_LOGIN_USER_BY_ID, variables: { id: id} })
            // ]).then(res => {
                this.setState({
                    user,
                    // isSuper: true,//res[0].success && userType && userType === 'admin',
                    // isAgent: userType && userType === 'agent',
                    // isSeniorAgent: userType && userType === 'senior agent',
                    // userData: userData && userData,
                    // isHscUser: email && email.includes('highstcapital.com')

                    isSuper: type && type === 'admin',
                    isAgent: type && type === 'agent',
                    isSeniorAgent: type && type === 'senior agent',
                    userData: userData && userData,
                    isHscUser: email && (email.toLowerCase().includes('highstcapital.com') || email.toLowerCase().includes('athenacapitalre.com')),
                    showChangePassword: false
                });
                 if (
                   email &&
                   (email.toLowerCase().includes("highstcapital.com") ||
                     email.toLowerCase().includes("athenacapitalre.com")) &&
                   browserHistory.getCurrentLocation().pathname === "/"
                 ) {
                   browserHistory.push({
                     pathname: "/hsc-stats",
                   });
                 }
            // });
        } else {
            this.setState({
                user,
                isSuper: false,
                isAgent: false,
                isSeniorAgent: false,
                userData: false,
            });
        }
    }
 
    signOut() {
        localStorage.removeItem('authToken');
        // request(arc.path.api, {
        //  service: 'arcimedes',
        //  action: 'Authentication.logout',
        // });
        sessionStorage.clear(); 
        this.setState({
            user: false,
            isSuper: false,
            isAgent: false,
            isSeniorAgent: false,
            userData: false,
        });
    }
    updatePassword() {
        this.setState({
            showChangePassword: true
        }, () => {
            browserHistory.push('/change-password');
        });
    }
    clearCookies() {
        const cookies = document.cookie.split("; ");
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i];
          const eqPos = cookie.indexOf("=");//this code replace = and seperate Key and value, and stores key
          const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;// clear the cookie by past date so browser treat as expired cookie
        }
      }
 
    render() {
        const { user, isSuper, isAgent, userData, isSeniorAgent, isHscUser } = this.state;
        if (user === null) return null;
 
        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
                        <UserContext.Provider value={{userData, setUser: this.setUser}}>
                        <div className='Root' onKeyDown={this.handleKeyDown}>
                            <DocTitle title='STRIVE' />
                            <Header location={this.props.location} isSuper={isSuper} isAgent={isAgent} isSeniorAgent={isSeniorAgent} pathname={this.props.location.pathname} />
                            <Sidebar signOut={user ? this.signOut : null} location={this.props.location} isSuper={isSuper} isAgent={isAgent} isSeniorAgent={isSeniorAgent} pathname={this.props.location.pathname} isHscUser={isHscUser} updatePassword={this.updatePassword} userData={userData}>
                                {
                                    // // user ? React.cloneElement(this.props.children, { isSuper, isAgent, userData, isSeniorAgent }) : <Login setUser={this.setUser} />
                                    // !user ? <Login setUser={this.setUser} /> : this.state.showChangePassword ? 
                                    // // <ChangePassword onPasswordChange={() => this.setState({ showChangePassword: false })} /> 
                                    // <ChangePassword onPasswordChange={() => {localStorage.removeItem('authToken'); this.setState({user: false,isSuper: false,isAgent: false,isSeniorAgent: false,userData: null,showChangePassword: false}); }}/>
                                    // : React.cloneElement(this.props.children, { isSuper, isAgent, userData, isSeniorAgent })
                                    !user ? (
                                        <Login setUser={this.setUser} />
                                    ) : this.props.location.pathname === '/change-password' ? (
                                        <ChangePassword
                                            onPasswordChange={() => {
                                                this.setState({ showChangePassword: false, user: false,
                                                    isSuper: false,
                                                    isAgent: false,
                                                    isSeniorAgent: false,
                                                    userData: false, }, () => {
                                                    localStorage.removeItem('authToken'); // Force logout
                                                    browserHistory.push('/'); // Redirect to login
                                                });
                                            }}
                                        />
                                    ) : (
                                        React.cloneElement(this.props.children, { isSuper, isAgent, userData, isSeniorAgent })
                                    )
                                }
                            </Sidebar>
                        </div>
                        </UserContext.Provider>
                    )
                }}
            </ApolloConsumer>
        );
    }
}